import "@/App.css";
import ClarityCheck from "./components/ClarityCheck";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App ks-grain">
      <ClarityCheck />
      <Toaster
        theme="dark"
        position="top-center"
        toastOptions={{
          style: {
            background: "#121214",
            color: "#f5f2ec",
            border: "1px solid rgba(245,242,236,0.18)",
            fontFamily: "Georgia, 'Times New Roman', serif",
          },
        }}
      />
    </div>
  );
}

export default App;
